import { Button, Modal, Form, Input, message, InputNumber, Select } from "antd";
import API from "../../../../services/api-request";
import { useEffect } from "react";

const EditMaterialHandling = (props) => {
  const [editForm] = Form.useForm();

  const onFinish = async (values) => {
    const { key, cost, type } = values;

    const dataForm = {
      key,
      cost,
      type,
    };

    await API.Put("material-handling/" + props?.selectedData?.id, dataForm)
      .then(() => {
        message.success("Material Handling has been edited");
        props.onGetMaterialHandling();
        editForm.resetFields();
        props.onShowEdit(false);
      })
      .catch((err) => {
        console.log(err);
        message.info(`${err?.response?.data?.error}`);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowEdit(false);
    editForm.resetFields();
  };

  const typeOptions = [
    {
      value: "custom",
      label: "Custom",
    },
    {
      value: "overtime",
      label: "Overtime",
    },
    {
      value: "normal",
      label: "Normal",
    },
  ];

  useEffect(() => {
    editForm.setFieldsValue(props.selectedData);
  }, [props.selectedData]);

  useEffect(() => {
    if (!props.showEdit) {
      editForm.resetFields();
    }
  }, [props.showEdit]);

  return (
    <>
      <Modal
        title="Edit Material Handling"
        open={props.showEdit}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => editForm.submit()}>
            Submit
          </Button>,
        ]}
      >
        <Form
          form={editForm}
          name="Edit Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          {/* <Form.Item
            label="Key"
            name="key"
            rules={[{ required: true, message: "Please input key!" }]}
          >
            <Input placeholder="Input Key" />
          </Form.Item> */}
          <Form.Item
            label="Cost"
            name="cost"
            rules={[{ required: true, message: "Please input cost!" }]}
          >
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              controls={false}
              placeholder="Input Cost"
            />
          </Form.Item>
          {/* <Form.Item
            label="Type"
            name="type"
            rules={[{ required: true, message: "Please input type!" }]}
          >
            <Select options={typeOptions} placeholder="Input Type" />
          </Form.Item> */}
        </Form>
      </Modal>
    </>
  );
};

export default EditMaterialHandling;
